module.exports = __webpack_public_path__ + "img/diginext-gray.3e807e4.png";